import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/navbar/navbarComponent";
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ingresoFoto } from "../../redux/actions";
import Button from "../../components/button";

function FotoComponent() {
  const webcamRef = useRef(null);
  const [imagen, setImagen] = useState(null);


  const capturarFoto = async () => {
    const captura = webcamRef.current.getScreenshot();

    if (captura) {
      // Convertir Base64 a Blob
      const blob = await fetch(captura).then(res => res.blob());

      // Crear un objeto File
      const file = new File([blob], `foto_${Date.now()}.jpeg`, { type: "image/jpeg" });

      setImagen(file);
    }
  };


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleConfirmar = () => {
    if (imagen) {
      dispatch(ingresoFoto(imagen));
      navigate('/ingreso_confirmacion');
    } else {
      console.error("No hay imagen capturada");
    }
  };

  const handleback = () => {
    navigate(-1)
  }

  // Para la imagen
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (imagen) {
      const objectUrl = URL.createObjectURL(imagen);
      setPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [imagen]);

  return (
    <div >
      <Navbar />
      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF]">

        {imagen ? (
          <div className="flex flex-col  items-center">
            <img src={preview} alt="Captura" className=" mt-[4rem] rounded-lg overflow-hidden" />

            <div className=" mt-[4rem] justify-center items-center flex">
              <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                <Button variant="secondary" size="lg" fullWidth onClick={() => setImagen(null)}>
                  Volver atrás
                </Button>
                <Button size="lg" fullWidth onClick={() => handleConfirmar()}>
                  Confirmar foto
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col  items-center">
            <div className=" mt-[4rem] rounded-lg overflow-hidden">
              <Webcam
                audio={false}

                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={500}
                videoConstraints={{
                  facingMode: { exact: "environment" } // Usa la cámara trasera
                }}
              />
            </div>
            <button onClick={capturarFoto} className="flex flex-col justify-center items-center">
              <div className="w-20 h-20 absolute bg-[#d84e4e] rounded-full border-8 border-white" />
            </button>



            <div className=" mt-[4rem] justify-center items-center flex">
              <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                <Button variant="secondary" size="lg" fullWidth onClick={() => handleback()}>
                  Volver atrás
                </Button>
                <Button size="lg" fullWidth disabled>
                  Confirmar foto
                </Button>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>

  );
};
export default FotoComponent


